import { render, staticRenderFns } from "./SealItem.vue?vue&type=template&id=24ccfb9c&scoped=true"
import script from "./SealItem.vue?vue&type=script&lang=js"
export * from "./SealItem.vue?vue&type=script&lang=js"
import style0 from "./SealItem.vue?vue&type=style&index=0&id=24ccfb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccfb9c",
  null
  
)

export default component.exports